import _ from 'lodash';
// import React from 'react';
import { message } from 'antd';

import mElectronApi from '../../util/electron';
import History from '../../util/history';
import CONSTANT from '../../constant';
// import Config from '../../config';

import Emitter from '../../services/emitter';
import Mscratch from '../../services/mscratch';
import { editingTarget, loadExt } from '../../services/mscratch/ext';
import ConnectAction from '../connect/action';
import ExtensionAction from '../extension/action';
import SpriteAction from '../sprite/action';
import { uploadCode } from './common';
import projectModel from '../../model/project.model';
import Connect from '../../services/connect';
import platform from '../../util/platform';

// const CONNECT_STATUS = CONSTANT.CONNECT_STATUS;
const deviceInfo = device => device ? `deviceId=${device.deviceId}&name=${device.name}` : '';

export default (store) => {

    const onMscratchReady = () => {
        // 获取扩展列表
        // store.dispatch(ExtensionAction.list('common', true));
        // store.dispatch(ExtensionAction.list('devices', true));
        // 禁用状态检查
        Emitter.emit('CheckDisableBlocks', 0);
        // 同步连接状态
        // Emitter.emit('SyncConnectState', CONSTANT.SYNC_CONNECT_STATE_TYPE.ONREADY, false);
        mElectronApi.onReady();
    };

    const onUploadCodeSuccess = isRetry => {
        Emitter.emit('LogUploadCode', editingTarget().id, true, isRetry ? 'retry' : '');
    };

    const onUploadCodeFail = isRetry => {
        Emitter.emit('LogUploadCode', editingTarget().id, false, isRetry ? 'retry' : '');
    };

    const onProjectEndLoad = () => {
        // 禁用状态检查
        Emitter.emit('CheckDisableBlocks', 1);
        // 同步连接状态
        Emitter.emit('SyncConnectState', CONSTANT.SYNC_CONNECT_STATE_TYPE.PROJECT, false);
        reloadExt(CONSTANT.DEVICE.CODEY);
        // 设置保存状态为：已保存
        setTimeout(() => {
            projectModel.setSaved();
        }, 300);
        setTimeout(() => {
            projectModel.setLoaded(true);
        }, 600);
    };

    const onProjectStartLoad = () => {
        projectModel.setLoadingPageState(true);
    };

    const onConnectReceive = (err, data) => {
        Mscratch.doReceived(data);
    };

    const onClickUploadCode = () => {
        uploadCode(store);
    };

    const onSetSender = (buff) => {
        const { connect } = store.getState();
        if (connect.connectionInfo && connect.connectionInfo.connectionId) {
            Connect.send(connect.type, connect.connectionInfo.connectionId, buff, (err, sendInfo) => {
                // console.log('listener.mscrach.onSetSender ', err, sendInfo);
            });
        }
    };

    const onClickConnect = (device) => {
        let path;
        if(platform.isChromeOS){
            path = `/nodriver?deviceId=${device.deviceId}&name=${device.name}&os=chromeos`;
        }else{
            path = `/nodriver?deviceId=${device.deviceId}&name=${device.name}`;
        }
        if (ConnectAction.Service.isInstall()) {
            path = `/connect?deviceId=${device.deviceId}&name=${device.name}`;
        }
        if (path && History.location.pathname !== path) {
            History.replace(path);
        }
    };

    const onDisconnect = (device) => {
        const { connect } = store.getState();
        if (!connect.connectionInfo) {
            console.error('listeners.mscratch onDisconnect, invalid connection info ', connect);
        }
        store.dispatch(ConnectAction.disconnect(connect.type, connect.connectionInfo && connect.connectionInfo.connectionId, device));
    };

    const onClickExtList = () => {
        History.push('/exts');
    };

    const onClickDeviceList = () => {
        History.push('/sprite/devices');
    };

    const onClickResetDevice = (device) => {
        console.log({ ClickResetDevice: device });
        History.push(`/updater/firmware?${deviceInfo(device)}&tag=reset`);
    };

    const onClickUpdateFirmware = (device) => {
        console.log({ ClickUpdateFirmware: device });
        History.push(`/updater/firmware?${deviceInfo(device)}`);
    };

    const onClickCalibrateColor = (device) => {
        console.log({ ClickCalibrateColorSensor: device });
        History.push(`/calibrate/${CONSTANT.SENSOR_CALIBRATE_TYPE.COLOR}`);
    };

    const onClickCalibrateGyro = (device) => {
        console.log({ onClickCalibrateGyro: device });
        History.push(`/calibrate/${CONSTANT.SENSOR_CALIBRATE_TYPE.GYRO}`);
    };

    const onUploadOnlineFirmware = () => {
        if (History.location.pathname === '/') {
            History.push('/updater/firmware/progress');
            Emitter.emit('uploadFirmwarePrepare');
        }
    };

    const onFlyoutBlockClicked = (block) => {
        const { type, disabled } = block;
        const { intlr } = store.getState();
        if (CONSTANT.LOGIN_AVAILABLE_BLOCKS.indexOf(type) !== -1 && disabled) {
            if (type.indexOf('iot.') === 0) {
                message.warn(intlr.messages['BLOCK.USE.NEED.LOGINANDOPEN'], 2);
            } else {
                message.warn(intlr.messages['BLOCK.USE.NEED.LOGIN'], 2);
            }
        }
    };

    const reloadExt = (type) => {
        const { extension } = store.getState();
        let { exts, installed } = extension;
        exts = _.filter(exts, (ext) => {
            return ext.targets && ext.targets.indexOf(type) >= 0;
        });
        _.isArray(exts) && exts.forEach((info) => {
            if (installed.indexOf(info.id.toLowerCase()) >= 0) {
                loadExt(info);
            }
        });
    };

    const onDeviceSpriteAdd = (device) => {
        console.log({ DeviceSpriteAdd: device });
        reloadExt(device.name);
        // console.log(list);
        // store.dispatch(ConnectAction.resetConnectDevice(device, true));
        // 同步连接状态
        // Emitter.emit('SyncConnectState', CONSTANT.SYNC_CONNECT_STATE_TYPE.ADD_DEVICE, device);
    };

    const onDeviceSpriteDelete = (device) => {
        console.log({ DeviceSpriteDelete: device });
        // store.dispatch(ConnectAction.resetConnectDevice(device, true));
        // 同步连接状态
        // Emitter.emit('SyncConnectState', CONSTANT.SYNC_CONNECT_STATE_TYPE.REMOVE_DEVICE, device);
    };

    const onExtsFound = (exts) => {
        if (exts && exts.exts) {
            ExtensionAction.load(exts.exts);
        }
    };

    const onClickedOpenSoundRecorder = () => {
        Mscratch.openRecordSound();
    };

    const onLocaleDataUpdated = (langKey, langData) => {
        if (langData && langData.mscratchMsgs) {
            Mscratch.addLocaleData(langKey, langData.mscratchMsgs, langData.locale);
        }
    };

    const onSwitchLanguage = lang => {
        Mscratch.changeLanguage(lang);
    };

    // Mscratch 准备好了
    Emitter.on('MscratchReady', onMscratchReady);
    // 设置发送通道
    Emitter.on('SetSender', onSetSender);
    // 连接回发数据事件
    Emitter.on('ConnectReceive', onConnectReceive);
    // 项目发生变化触发
    // Emitter.on('ProjectChange', onProjectChange);
    // 更新代码触发事件
    Emitter.on('ProjectStartLoad', onProjectStartLoad);
    Emitter.on('ProjectEndLoad', onProjectEndLoad);
    // 点击连接设备
    Emitter.on('ClickConnect', onClickConnect);
    // 点击断开设备连接
    Emitter.on('ClickDisconnect', onDisconnect);
    // 点击扩展列表
    Emitter.on('ClickExtList', onClickExtList);
    // 点击设备列表
    Emitter.on('ClickDeviceList', onClickDeviceList);
    // 添加了设备角色
    Emitter.on('DeviceSpriteAdd', onDeviceSpriteAdd);
    // 移除了设备角色
    Emitter.on('DeviceSpriteDelete', onDeviceSpriteDelete);
    // 点击上传代码
    Emitter.on('ClickUploadCode', onClickUploadCode);
    // 上传 <mcore | auriga> 在线固件
    Emitter.on('ClickUploadOnlineFirmware', onUploadOnlineFirmware);
    // 恢复出厂设置
    Emitter.on('ClickResetDevice', onClickResetDevice);
    // 点击更新固件
    Emitter.on('ClickUpdateFirmware', onClickUpdateFirmware);
    // 点击校正颜色传感器
    Emitter.on('ClickCalibrateColor', onClickCalibrateColor);
    // 点击校正陀螺仪
    Emitter.on('ClickCalibratGyro', onClickCalibrateGyro);
    // 侧边栏块点击触发的操作
    Emitter.on('FlyoutBlockClicked', onFlyoutBlockClicked);
    // 点击打开角色
    Emitter.on('ClickedOpenSprite', (type) => {
        History.push(`/sprite/${type}`);
    });
    // 点击打开录音弹窗
    Emitter.on('ClickedOpenSoundRecorder', onClickedOpenSoundRecorder);
    // 点击保存录音
    Emitter.on('ClickRecordSound', (sound) => SpriteAction.recordSound(sound));
    Emitter.on('ExtsFound', onExtsFound);
    // 添加角色
    Emitter.on('AddSprite', async (type, data, autoOpenCostumeEditor = false, cb) => {
        let afterAddedSprite = null;
        let isLoaded = true;
        const { intlr } = store.getState();
        switch (type) {
            case CONSTANT.SPRITE_TYPE.DEVICES:
                isLoaded = await loadExt(data);
                !isLoaded && message.warn(intlr.messages['NETWORK.ERR.MSG'], 2);
                break;
            case CONSTANT.SPRITE_TYPE.LIBS:
            case CONSTANT.SPRITE_TYPE.USER_LIBS:
                afterAddedSprite = Mscratch.addSprite(data);
                break;

            case CONSTANT.SPRITE_TYPE.COSTUMES:
            case CONSTANT.SPRITE_TYPE.USER_COSTUMES:
                afterAddedSprite = Mscratch.addCostume(data);
                break;

            case CONSTANT.SPRITE_TYPE.BACKDROPS:
            case CONSTANT.SPRITE_TYPE.USER_BACKDROPS:
                afterAddedSprite = Mscratch.addBackdrop(data);
                break;

            case CONSTANT.SPRITE_TYPE.SOUNDS:
            case CONSTANT.SPRITE_TYPE.USER_SOUNDS:
                Mscratch.addSound(data);
                break;

            default:
                break;
        }
        if (afterAddedSprite && autoOpenCostumeEditor) {
            afterAddedSprite.then(Mscratch.costumeEditorShow);
        }
        _.isFunction(cb) && cb(isLoaded);
    });
    // 扩展加载完成
    Emitter.on('LoadedExt', (id) => {
        // if (CONSTANT.LOGIN_BLOCKS_BELONGTO_EXT.indexOf(id) !== -1) {
        //     const { isLogin } = store.getState().account;
        //     if (isLogin) {
        //         Mscratch.enableBlocks(CONSTANT.LOGIN_AVAILABLE_BLOCKS);
        //     } else {
        //         Mscratch.disableBlocks(CONSTANT.LOGIN_AVAILABLE_BLOCKS);
        //     }
        // }
    });

    // TODO:  iot 置灰临时接口, add by jeremy
    if (!window.MbApi) {
        window.MbApi = {};
    }
    // const LOGIN_AVAILABLE_BLOCKS_FOR_IOT = [
    //     'iot.ifttt_pub',
    //     'iot.ifttt_recv',
    //     'iot.data_addtolist_cloudlist',
    //     'iot.data_itemoflist_cloudlist',
    //     'iot.data_lengthoflist_cloudlist',
    //     'iot.iot_air',
    //     'iot.iot_sun',
    //     'iot.iot_weather'
    // ];
    window.MbApi.enableBlocks = (blocks) => {
        Mscratch.enableBlocks(blocks);
    };
    window.MbApi.disableBlocks = (blocks) => {
        Mscratch.disableBlocks(blocks);
    };

    // 是否登录
    window.MbApi.isLogin = () => {
        let account = store.getState().account;
        return (account && account.isLogin);
    };

    // 上传代码成功
    Emitter.on('UploadCodeSuccess', onUploadCodeSuccess);
    // 上传代码失败
    Emitter.on('UploadCodeFailed', onUploadCodeFail);

    // 当语言更新
    Emitter.on('LocaleDataUpdated', onLocaleDataUpdated);
    // 当语言切换
    Emitter.on('SwitchLanguage', onSwitchLanguage);
};